<template>
  <div class="box">
    <div class="box-header">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> Resultado do cadastro na APS
      </h4>
      <vue-select
        name="situacao-cadastro"
        v-model="indicador"
        class="select-situacao-cadastro"
        :clearable="true"
        :options="optionsIndicador"
        label="label"
        placeholder="Situação cadastro"
        @input="onChangeIndicador"
        :disabled="disabledSelectResultado"
      >
        <template slot="option" slot-scope="option">
          {{ option.label }}
        </template>
        <div slot="no-options">Não há opções correspondentes</div>
      </vue-select>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>Total</th>
            <th>
              {{ labelColunaAtualizados }}
              <span
                v-b-tooltip.hover
                :title="textTooltipAtualizados"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              {{ labelColunaDesatualizados }}
              <span
                v-b-tooltip.hover
                :title="textTooltipDesatualizados"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Município</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="secretaria_municipal_de_saude_total_no_municipio"
                :loading="loading"
              ></loader>
            </td>

            <td class="text-center green font-weight-bold">
              <loader
                :value="`${(
                  (secretaria_municipal_de_saude_total_no_municipio / 100) *
                  secretaria_municipal_de_saude_no_municipio_atualizados
                ).toFixed(
                  0
                )} (${secretaria_municipal_de_saude_no_municipio_atualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center red font-weight-bold">
              <loader
                :value="`${(
                  (secretaria_municipal_de_saude_total_no_municipio / 100) *
                  secretaria_municipal_de_saude_no_municipio_desatualizados
                ).toFixed(
                  0
                )} (${secretaria_municipal_de_saude_no_municipio_desatualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>Equipe</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="secretaria_municipal_de_saude_total_na_equipe"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center green font-weight-bold">
              <loader
                :value="`${(
                  (secretaria_municipal_de_saude_total_na_equipe / 100) *
                  secretaria_municipal_de_saude_na_equipe_atualizados
                ).toFixed(
                  0
                )} (${secretaria_municipal_de_saude_na_equipe_atualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center red font-weight-bold">
              <loader
                :value="`${(
                  (secretaria_municipal_de_saude_total_na_equipe / 100) *
                  secretaria_municipal_de_saude_na_equipe_desatualizados
                ).toFixed(
                  0
                )} (${secretaria_municipal_de_saude_na_equipe_desatualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>ACS</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="secretaria_municipal_de_saude_total_no_acs"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center green font-weight-bold">
              <loader
                :value="`${(
                  (secretaria_municipal_de_saude_total_no_acs / 100) *
                  secretaria_municipal_de_saude_no_acs_atualizados
                ).toFixed(
                  0
                )} (${secretaria_municipal_de_saude_no_acs_atualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center red font-weight-bold">
              <loader
                :value="`${(
                  (secretaria_municipal_de_saude_total_no_acs / 100) *
                  secretaria_municipal_de_saude_no_acs_desatualizados
                ).toFixed(
                  0
                )} (${secretaria_municipal_de_saude_no_acs_desatualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
          </tr>
        </tbody>
      </table>
      <FonteEsusPecGlobal
        texto="Cadastros registrados até"
        :data="data_secretaria_de_saude"
      />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  components: {
    Loader,
  },
  props: {
    labelColunaAtualizados: {
      type: String,
      default: '',
    },
    labelColunaDesatualizados: {
      type: String,
      default: '',
    },
    disabledSelectResultado: {
      type: Boolean,
      default: false,
    },
    resetarSelectTabelaResultado: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    secretaria_municipal_de_saude_total_no_municipio: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_no_municipio_atualizados: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_no_municipio_desatualizados: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_total_na_equipe: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_na_equipe_atualizados: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_na_equipe_desatualizados: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_total_no_acs: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_no_acs_atualizados: {
      type: [String, Number],
      default: '',
    },
    secretaria_municipal_de_saude_no_acs_desatualizados: {
      type: [String, Number],
      default: '',
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    selectedIndicador: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      indicador: null,
      optionsIndicador: [
        { label: 'FCI Atualizada e >90% completa', value: '29' },
        { label: 'FCI Atualizada e 100% completa', value: '28' },
        { label: 'FCI Atualizada', value: '0' },
        { label: 'FCI Completa', value: '27' },
      ],
      textTooltipAtualizados:
        'Cidadãos com cadastro atualizado há menos de 1 ano e completos',
      textTooltipDesatualizados:
        'Cidadão com cadastro desatualizados há mais de 1 ano ou incomplentos',
    }
  },
  mounted() {
    this.indicador = this.$props.selectedIndicador
  },
  watch: {
    labelColunaAtualizados: {
      handler(newValue, oldValue) {
        switch (newValue) {
          case 'Atualizados e completos':
            this.textTooltipAtualizados =
              'Cidadãos com cadastro atualizado há menos de 1 ano e completos'
            break
          case 'Atualizados':
            this.textTooltipAtualizados =
              'Cidadãos com cadastro atualizado há menos de 1 ano'
            break
          case 'Completos':
            this.textTooltipAtualizados =
              'Cidadãos com cadastro FCI completo (menos de 1 ano)'
            break
          default:
            break
        }
      },
    },
    labelColunaDesatualizados: {
      handler(newValue, oldValue) {
        switch (newValue) {
          case 'Desatualizados ou incompletos':
            this.textTooltipDesatualizados =
              'Cidadão com cadastro desatualizados há mais de 1 ano ou incomplentos'
            break
          case 'Desatualizados':
            this.textTooltipDesatualizados =
              'Cidadãos com cadastro atualizado há mais de 1 ano'
            break
          case 'Incompletos':
            this.textTooltipDesatualizados =
              'Cidadãos com cadastro FCI incompleto (mais de 1 ano)'
            break
          default:
            break
        }
      },
    },
  },
  methods: {
    onChangeIndicador(indicador) {
      this.$emit('onChangeIndicador', indicador)
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
